import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly loadingService = inject(LoadingService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestId = `http_${Date.now()}_${Math.random()}`;

    if (request.url.includes('/polling') || request.url.includes('/ws')) {
      return next.handle(request);
    }

    this.loadingService.startHttpRequest(requestId);

    return next.handle(request).pipe(
      tap({
        next: event => {
          if (event instanceof HttpResponse) {
            this.loadingService.completeHttpRequest(requestId);
          }
        },
        error: () => {
          this.loadingService.completeHttpRequest(requestId);
        },
        complete: () => {
          this.loadingService.completeHttpRequest(requestId);
        },
      }),
    );
  }
}
